import React from 'react';
import { Link } from 'react-router-dom';
import Spinner from './Spinner';

/**
 * <Button variant="primary" size="md" loading leftIcon={<Icon name="search" />}>Submit</Button>
 * Polymorphic: `to=` → react-router Link, `href=` → <a>, aksi hâlde <button>.
 * Bootstrap 5 sınıflarına delege eder; boyut/renk inline style taşımaz.
 */
const VARIANT_CLASS = {
  primary:   'btn-primary',
  secondary: 'btn-secondary',
  cyan:      'btn-cyan',
  danger:    'btn-danger',
  ghost:     'btn-ghost',
  outline:   'btn-outline-primary',
};
const SIZE_CLASS = { xs: 'btn-xs', sm: 'btn-sm', md: '', lg: 'btn-lg' };

const spinnerColor = {
  primary: '#fff', secondary: 'var(--accent)', cyan: '#fff',
  danger: '#fff', ghost: 'var(--text-secondary)', outline: 'var(--accent)',
};

export default function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled,
  leftIcon,
  rightIcon,
  to,
  href,
  type,
  className = '',
  style,
  children,
  ...rest
}) {
  const v = VARIANT_CLASS[variant] ? variant : 'primary';
  const classes = [
    'btn', VARIANT_CLASS[v], SIZE_CLASS[size] ?? '',
    'd-inline-flex', 'align-items-center', 'gap-2',
    className,
  ].filter(Boolean).join(' ');

  const content = (
    <>
      {loading
        ? <Spinner size="xs" thickness={2} color={spinnerColor[v] ?? '#fff'} />
        : leftIcon}
      {children && <span>{children}</span>}
      {!loading && rightIcon}
    </>
  );

  if (to && !disabled) {
    return <Link to={to} className={classes} style={style} {...rest}>{content}</Link>;
  }
  if (href && !disabled) {
    return <a href={href} className={classes} style={style} {...rest}>{content}</a>;
  }
  return (
    <button
      type={type || 'button'}
      className={classes}
      style={style}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {content}
    </button>
  );
}
